import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.reduce.js";
import "core-js/modules/esnext.iterator.some.js";
import Client from "./Client";
import SalePage from "./SalePage";
import OrderLine from "./OrderLine";
import User from "./User";
import OrderComment from "./OrderComment";
import OrderInvoice from "./OrderInvoice";
import Invoice from "./Invoice";
import Payment from "./Payment";
import Offer from "./Offer";
import moment from "moment";
import Product from "./Product";
import { date_time_format } from "@/assets/js/mcn-helpers";
import Model from "./Model";
export class Order extends Model {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "Id", {
      fieldName: 'order_id',
      fieldTitle: 'Order id',
      content: null
    });
    _defineProperty(this, "OrderId", {
      fieldName: 'order_id',
      fieldTitle: 'Order id',
      content: null
    });
    _defineProperty(this, "idAlias", {
      fieldName: 'order_id_alias',
      fieldTitle: 'Order id alias',
      content: null
    });
    _defineProperty(this, "OrderClient", {
      fieldName: 'order_client',
      fieldTitle: 'Order client',
      model: Client,
      content: null
    });
    _defineProperty(this, "client", {
      fieldName: 'client',
      fieldTitle: 'Order client',
      model: Client,
      content: null
    });
    _defineProperty(this, "OrderCallAgent", {
      fieldName: 'order_call_agent',
      fieldTitle: 'Order call agent',
      model: User,
      content: null
    });
    _defineProperty(this, "OrderInvoices", {
      fieldName: 'order_invoices',
      fieldTitle: 'Order invoices',
      model: OrderInvoice,
      content: []
    });
    _defineProperty(this, "OrderSalePage", {
      fieldName: 'order_sale_page',
      fieldTitle: 'Order sale page',
      model: SalePage,
      content: null
    });
    _defineProperty(this, "OrderWithTrashedSalePage", {
      fieldName: 'order_with_trashed_sale_page',
      fieldTitle: 'Order sale page',
      model: SalePage,
      content: null
    });
    _defineProperty(this, "withTrashedSalePage", {
      fieldName: 'with_trashed_sale_page',
      fieldTitle: 'Order sale page',
      model: SalePage,
      content: null
    });
    _defineProperty(this, "OrderStatus", {
      fieldName: 'order_status',
      fieldTitle: 'Order status',
      content: null
    });
    _defineProperty(this, "OrderOrderLines", {
      fieldName: 'order_lines',
      fieldTitle: 'Order order lines',
      model: OrderLine,
      content: []
    });
    _defineProperty(this, "OrderTrackingCode", {
      fieldName: 'order_tracking_code',
      fieldTitle: 'Order tracking code',
      content: null
    });
    _defineProperty(this, "OrderTrackingLink", {
      fieldName: 'order_tracking_link',
      fieldTitle: 'Order tracking link',
      content: null
    });
    _defineProperty(this, "OrderCreationDate", {
      fieldName: 'created_at',
      fieldTitle: 'Order creation date',
      content: null
    });
    _defineProperty(this, "OrderComments", {
      fieldName: 'order_call_agent_order_comments',
      fieldTitle: 'Order creation date',
      model: OrderComment,
      content: []
    });
    _defineProperty(this, "OrderFulfillementPrice", {
      fieldName: 'order_fulfillment_price',
      fieldTitle: 'Order fulfillment price',
      content: null
    });
    _defineProperty(this, "OrderUpSellPrice", {
      fieldName: 'order_upsell_price',
      fieldTitle: 'Order upsell price',
      content: null
    });
    _defineProperty(this, "OrderShippingPrice", {
      fieldName: 'order_shipping_price',
      fieldTitle: 'Order shipping price',
      content: null
    });
    _defineProperty(this, "OrderReturnsPrice", {
      fieldName: 'order_returns_price',
      fieldTitle: 'Order returns price',
      content: null
    });
    _defineProperty(this, "OrderTaxPrice", {
      fieldName: 'order_tax_percentage',
      fieldTitle: 'Order tax price',
      content: null
    });
    _defineProperty(this, "OrderOtherPrice", {
      fieldName: 'order_other_percentage',
      fieldTitle: 'Order other price',
      content: null
    });
    _defineProperty(this, "OrderShippingNote", {
      fieldName: 'order_call_agent_shipping_note',
      fieldTitle: 'Order shipping note',
      content: null
    });
    _defineProperty(this, "OrderUsdTotalConfirmed", {
      fieldName: 'order_lines_sum_order_line_total_confirmed_usd',
      content: null
    });
    _defineProperty(this, "OrderRemittanceInvoice", {
      fieldName: 'order_remittance_invoice',
      model: Invoice,
      content: null
    });
    _defineProperty(this, "OrderTotalConfirmedUsdSum", {
      fieldName: 'total_confirmed_usd_sum',
      content: 0
    });
    _defineProperty(this, "OrderSentToWarehouseApi", {
      fieldName: 'is_sent_to_warehouse_api',
      content: null
    });
    _defineProperty(this, "OrderSentToWarehouse", {
      fieldName: 'is_sent_to_warehouse',
      content: null
    });
    _defineProperty(this, "OrderSentToAdvertiser", {
      fieldName: 'is_sent_to_advertiser',
      content: null
    });
    _defineProperty(this, "OrderPaymentType", {
      fieldName: 'order_payment_type',
      content: null
    });
    _defineProperty(this, "OrderPayment", {
      fieldName: 'order_payment',
      model: Payment,
      content: null
    });
    _defineProperty(this, "OrderTotalConfirmedUsd", {
      fieldName: 'order_total_confirmed_usd',
      content: null
    });
    _defineProperty(this, "OrderTotalConfirmed", {
      fieldName: 'order_total_confirmed',
      content: null
    });
    _defineProperty(this, "paymentStatus", {
      fieldName: 'payment_status',
      content: null
    });
    _defineProperty(this, "affiliatePaid", {
      fieldName: 'is_affiliate_paid',
      content: false
    });
    _defineProperty(this, "warehousePaid", {
      fieldName: 'is_warehouse_paid',
      content: false
    });
    _defineProperty(this, "getOrderRemittance", () => {
      return this.OrderOrderLines.content.reduce((a, b) => a + b.OrderLineUsdConfirmedTotal.content, 0);
    });
    _defineProperty(this, "getOrderTotalCommission", () => {
      var _offer$getOfferPayout, _offer$getOfferCommis;
      let offer = this.getWithTrashedOffer();
      let offer_payout = (_offer$getOfferPayout = offer === null || offer === void 0 ? void 0 : offer.getOfferPayout()) !== null && _offer$getOfferPayout !== void 0 ? _offer$getOfferPayout : 0;
      let offer_commission = (_offer$getOfferCommis = offer === null || offer === void 0 ? void 0 : offer.getOfferCommission()) !== null && _offer$getOfferCommis !== void 0 ? _offer$getOfferCommis : 0;
      return offer_payout + offer_commission;
    });
    _defineProperty(this, "getOrderExpenses", () => {
      let has_upsell = false;
      let order_total = this.OrderOrderLines.content.reduce((a, b) => {
        if (b.OrderLineType.content === 'upsell') has_upsell = true;
        return a + b.OrderLineUsdConfirmedTotal.content;
      }, 0);
      return this.OrderStatus.content !== 'returned' ? order_total / 100 * (this.OrderTaxPrice.content + this.OrderOtherPrice.content) + this.OrderFulfillementPrice.content + this.OrderUpSellPrice.content + (has_upsell ? this.OrderUpSellPrice.content : 0) : this.OrderReturnsPrice.content + this.OrderShippingPrice.content;
    });
  }
  getOrderAlias() {
    return this.idAlias.content;
  }
  getMomentCreationDate() {
    return moment.utc(this.getCreatedAt()).format(date_time_format);
  }
  getCustomerName() {
    let customer = this.getClient();
    return customer instanceof Client ? customer.getFullName() : null;
  }
  getSeller(trashed = false) {
    let salePage = this.getSalePage(trashed);
    return salePage instanceof SalePage ? salePage.getSeller() : null;
  }
  getSellerName(trashed = false) {
    let seller = this.getSeller(trashed);
    return seller instanceof User ? seller.getUserName() : null;
  }
  getPaymentStatus() {
    return this.paymentStatus.content;
  }
  getOrderTotalConfirmedUsd() {
    var _ref, _this$OrderTotalConfi, _this$OrderTotalConfi2;
    return (_ref = (_this$OrderTotalConfi = (_this$OrderTotalConfi2 = this.OrderTotalConfirmedUsd) === null || _this$OrderTotalConfi2 === void 0 ? void 0 : _this$OrderTotalConfi2.content) !== null && _this$OrderTotalConfi !== void 0 ? _this$OrderTotalConfi : this.OrderOrderLines.content.reduce((somme, order_line) => {
      return somme + (order_line instanceof OrderLine ? order_line.getOrderLineUsdConfirmedTotal() : 0);
    }, 0)) !== null && _ref !== void 0 ? _ref : 0;
  }
  getOrderTotalConfirmed() {
    var _ref2, _this$OrderTotalConfi3, _this$OrderTotalConfi4;
    return (_ref2 = (_this$OrderTotalConfi3 = (_this$OrderTotalConfi4 = this.OrderTotalConfirmed) === null || _this$OrderTotalConfi4 === void 0 ? void 0 : _this$OrderTotalConfi4.content) !== null && _this$OrderTotalConfi3 !== void 0 ? _this$OrderTotalConfi3 : this.OrderOrderLines.content.reduce((somme, order_line) => {
      return somme + (order_line instanceof OrderLine ? order_line.getOrderLineConfirmedTotal() : 0);
    }, 0)) !== null && _ref2 !== void 0 ? _ref2 : 0;
  }
  getCreatedAt() {
    return this.OrderCreationDate.content;
  }
  getId() {
    return this.Id.content;
  }
  getWithTrashedSalePage() {
    var _this$OrderWithTrashe, _this$OrderWithTrashe2, _this$OrderSalePage;
    return (_this$OrderWithTrashe = (_this$OrderWithTrashe2 = this.OrderWithTrashedSalePage) === null || _this$OrderWithTrashe2 === void 0 ? void 0 : _this$OrderWithTrashe2.content) !== null && _this$OrderWithTrashe !== void 0 ? _this$OrderWithTrashe : (_this$OrderSalePage = this.OrderSalePage) === null || _this$OrderSalePage === void 0 ? void 0 : _this$OrderSalePage.content;
  }
  getWithTrashedOffer() {
    var _this$getWithTrashedS;
    return (_this$getWithTrashedS = this.getWithTrashedSalePage()) === null || _this$getWithTrashedS === void 0 ? void 0 : _this$getWithTrashedS.getSalePageWithTrashedOffer();
  }
  static isValidOrderStatus(status) {
    return Order.getAllOrderStatuses().includes(status);
  }
  status() {
    var _this$OrderStatus;
    return (_this$OrderStatus = this.OrderStatus) === null || _this$OrderStatus === void 0 ? void 0 : _this$OrderStatus.content;
  }
  isDelivered() {
    return this.status() === Order.DELIVERED_STATUS;
  }
  isShipped() {
    return this.status() === Order.SHIPPED_STATUS;
  }
  static getAllOrderStatuses() {
    return [Order.PENDING_STATUS, Order.CONFIRMED_STATUS, Order.SHIPPED_STATUS, Order.DELIVERED_STATUS, Order.CANCELED_STATUS, Order.RETURNED_STATUS, Order.PROCESSING_STATUS, Order.NO_ANSWER_STATUS];
  }
  getOrderStatus() {
    var _this$OrderStatus2;
    return (_this$OrderStatus2 = this.OrderStatus) === null || _this$OrderStatus2 === void 0 ? void 0 : _this$OrderStatus2.content;
  }
  getStatus() {
    var _this$OrderStatus3;
    return (_this$OrderStatus3 = this.OrderStatus) === null || _this$OrderStatus3 === void 0 ? void 0 : _this$OrderStatus3.content;
  }
  getOrderOrdersLines() {
    var _this$OrderOrderLines, _this$OrderOrderLines2;
    return (_this$OrderOrderLines = (_this$OrderOrderLines2 = this.OrderOrderLines) === null || _this$OrderOrderLines2 === void 0 ? void 0 : _this$OrderOrderLines2.content) !== null && _this$OrderOrderLines !== void 0 ? _this$OrderOrderLines : [];
  }
  getOrderTotalAmount() {
    return this.getOrderOrdersLines().reduce((s, order_lines) => {
      if (order_lines instanceof OrderLine) return s + order_lines.getOrderLineUsdConfirmedTotal();
      return s + null;
    }, 0);
  }
  getOrderSalePage() {
    var _this$OrderSalePage2;
    return (_this$OrderSalePage2 = this.OrderSalePage) === null || _this$OrderSalePage2 === void 0 ? void 0 : _this$OrderSalePage2.content;
  }
  getSalePage(trashed = false) {
    if (trashed) {
      var _ref3, _this$OrderWithTrashe3;
      return (_ref3 = (_this$OrderWithTrashe3 = this.OrderWithTrashedSalePage.content) !== null && _this$OrderWithTrashe3 !== void 0 ? _this$OrderWithTrashe3 : this.withTrashedSalePage.content) !== null && _ref3 !== void 0 ? _ref3 : this.OrderSalePage.content;
    }
    return this.OrderSalePage.content;
  }
  getPageUrl(trashed = true) {
    let page = this.getSalePage(trashed);
    return page instanceof SalePage ? page.getSalePageLink() : null;
  }
  getOrderOfferPayout() {
    let offer = this.getOffer(true);
    return offer instanceof Offer ? offer.getPayout() : null;
  }
  getOrderLines() {
    var _this$OrderOrderLines3;
    return Array.isArray((_this$OrderOrderLines3 = this.OrderOrderLines) === null || _this$OrderOrderLines3 === void 0 ? void 0 : _this$OrderOrderLines3.content) ? this.OrderOrderLines.content : [];
  }
  getOfferCountry(trashed = false) {
    let offer = this.getOffer(trashed);
    return offer instanceof Offer ? offer.getCountry() : null;
  }
  getOffer(trashed = false) {
    let salePage = this.getSalePage(trashed);
    return salePage instanceof SalePage ? salePage.getOffer(trashed) : null;
  }
  getOfferRequiredCommissionStatus() {
    let offer = this.getOffer(true);
    return offer instanceof Offer ? offer.statusRequiredForCommission() : Order.DELIVERED_STATUS;
  }
  isDeliveredOfferRequiredCommissionStatus() {
    return this.getOfferRequiredCommissionStatus() === Order.DELIVERED_STATUS;
  }
  isConfirmedOfferRequiredCommissionStatus() {
    return this.getOfferRequiredCommissionStatus() === Order.CONFIRMED_STATUS;
  }
  getPayment() {
    return this.OrderPayment.content;
  }
  getPaymentMethod() {
    let payment = this.getPayment();
    return payment instanceof Payment ? payment.getPaymentMethod() : null;
  }
  getPaymentType() {
    return this.OrderPaymentType.content;
  }
  isCardPaymentOrder() {
    return this.getPaymentType() === Offer.CARD_PAYMENT_TYPE;
  }
  isCodPaymentOrder() {
    return this.getPaymentType() === Offer.COD_PAYMENT_TYPE;
  }
  getClient() {
    var _this$OrderClient$con;
    return (_this$OrderClient$con = this.OrderClient.content) !== null && _this$OrderClient$con !== void 0 ? _this$OrderClient$con : this.client.content;
  }
  getClientCountry() {
    let client = this.getClient();
    return client instanceof Client ? client.getCountry() : null;
  }
  isSentToWarehouse() {
    return this.OrderSentToWarehouse.content;
  }
  getTrackingLink() {
    return this.OrderTrackingLink.content;
  }
  isSentToAdvertiser() {
    return this.OrderSentToAdvertiser.content;
  }
  hasStoredUpsell() {
    return this.getOrderLines().some(orderLine => orderLine instanceof OrderLine && orderLine.isUpSell() && orderLine.hasQuantityConfirmed());
  }
  hasCalledUpsell() {
    return this.getOrderLines().some(orderLine => orderLine instanceof OrderLine && orderLine.isUpSell() && orderLine.hasQuantityConfirmed() > orderLine.getQuantity());
  }
  getCountry() {
    let client = this.getClient();
    return client instanceof Client ? client.getCountry() : null;
  }
  getProduct(trashed = false) {
    let offer = this.getOffer(trashed);
    return offer instanceof Offer ? offer.getProduct(trashed) : null;
  }
  getProductName(trashed = false) {
    let product = this.getProduct(trashed);
    return product instanceof Product ? product.getName() : null;
  }
  getOrderComments() {
    var _this$OrderComments$c;
    return (_this$OrderComments$c = this.OrderComments.content) !== null && _this$OrderComments$c !== void 0 ? _this$OrderComments$c : [];
  }
  canInvoice() {
    return this.isCardPaymentOrder() ? this.isDelivered() || this.isShipped() : this.isCodPaymentOrder() ? this.isDeliveredOfferRequiredCommissionStatus() ? this.isDelivered() : this.isConfirmedOfferRequiredCommissionStatus() ? [Order.CONFIRMED_STATUS, Order.SHIPPED_STATUS, Order.DELIVERED_STATUS].includes(this.getOrderStatus()) : false : false;
  }
  getMainOrderLine() {
    let orderLines = this.getOrderLines();
    return orderLines.find(ol => ol instanceof OrderLine ? ol.isMain() : false);
  }
  getUpsells() {
    let orderLines = this.getOrderLines();
    return orderLines.filter(ol => ol instanceof OrderLine ? ol.isUpsell() : false);
  }
  getCrossSells() {
    let orderLines = this.getOrderLines();
    return orderLines.filter(ol => ol instanceof OrderLine ? ol.isCrossSell() : false);
  }
  getUpsellsConfirmedQuantity() {
    let upsells = this.getUpsells();
    return upsells.reduce((init, upsell) => init + (upsell instanceof OrderLine ? upsell.getQuantityConfirmed() : 0), 0);
  }
  getUpsellsConfirmedTotal() {
    let upsells = this.getUpsells();
    return upsells.reduce((init, upsell) => init + (upsell instanceof OrderLine ? upsell.getTotalConfirmed() : 0), 0);
  }
  getCallUpsellQuantity() {
    let upsells = this.getUpsells();
    return upsells.reduce((init, upsell) => init + (upsell instanceof OrderLine ? upsell.getCallUpsellQuantity() : 0), 0);
  }
  getCallUpsellTotal() {
    let upsells = this.getUpsells();
    return upsells.reduce((init, upsell) => init + (upsell instanceof OrderLine ? upsell.getCallUpsellTotal() : 0), 0);
  }
  getTotalConfirmed() {
    let orderLines = this.getOrderLines();
    return orderLines.reduce((init, orderLine) => init + (orderLine instanceof OrderLine ? orderLine.getTotalConfirmed() : 0), 0);
  }
  getPayout() {
    let offer = this.getOffer(true);
    return offer instanceof Offer ? offer.getPayout() : null;
  }
  getOfferName() {
    let offer = this.getOffer(true);
    return offer instanceof Offer ? offer.getName() : null;
  }
  getPayoutWithCurrency() {
    let offer = this.getOffer(true);
    return ['$', offer instanceof Offer ? offer.getPayout() : null].join(' ');
  }
  getInvoices() {
    return this.OrderInvoices.content;
  }
  isWarehousePaid() {
    return this.warehousePaid.content;
  }
  getCalculatedOrderTotal() {
    return this.getOrderLines().reduce((init, next) => {
      return init + (next instanceof OrderLine && next.hasQuantity() ? next.getTotal() : 0);
    }, 0).toFixed(2);
  }
  getCalculatedOrderTotalWithCurrency() {
    let salePage = this.getSalePage(true);
    let currencySymbol = salePage instanceof SalePage ? salePage.getCurrencySymbol() : null;
    return [currencySymbol, this.getOrderLines().reduce((init, next) => {
      return init + (next instanceof OrderLine && next.hasQuantity() ? next.getTotal() : 0);
    }, 0).toFixed(2)].join(' ');
  }
  getCalculatedOrderTotalConfirmedWithCurrency() {
    let salePage = this.getSalePage(true);
    let currencySymbol = salePage instanceof SalePage ? salePage.getCurrencySymbol() : null;
    return [currencySymbol, this.getOrderLines().reduce((init, next) => {
      return init + (next instanceof OrderLine && next.hasQuantity() ? next.getTotalConfirmed() : 0);
    }, 0).toFixed(2)].join(' ');
  }
  getCalculatedOrderTotalConfirmed() {
    return this.getOrderLines().reduce((init, next) => {
      return init + (next instanceof OrderLine && next.hasQuantity() ? next.getTotalConfirmed() : 0);
    }, 0);
  }
  getCalculatedOrderUsdTotalConfirmed() {
    return this.getOrderLines().reduce((init, next) => {
      return init + (next instanceof OrderLine && next.hasQuantity() ? next.getUsdTotalConfirmed() : 0);
    }, 0);
  }
  getCalculatedOrderUsdTotal() {
    return this.getOrderLines().reduce((init, next) => {
      return init + (next instanceof OrderLine && next.hasQuantity() ? next.getUsdTotal() : 0);
    }, 0);
  }
  getCalculatedOrderUsdTotalWithCurrency() {
    return ['$', this.getOrderLines().reduce((init, next) => {
      return init + (next instanceof OrderLine && next.hasQuantity() ? next.getUsdTotal() : 0);
    }, 0).toFixed(2)].join(' ');
  }
  getCalculatedOrderUsdTotalConfirmedWithCurrency() {
    return ['$', this.getOrderLines().reduce((init, next) => {
      return init + (next instanceof OrderLine && next.hasQuantity() ? next.getUsdTotalConfirmed() : 0);
    }, 0).toFixed(2)].join(' ');
  }
  isAffiliatePaid() {
    return this.affiliatePaid.content;
  }
}
_defineProperty(Order, "PENDING_STATUS", 'pending');
_defineProperty(Order, "NO_ANSWER_STATUS", 'no_answer');
_defineProperty(Order, "CONFIRMED_STATUS", 'confirmed');
_defineProperty(Order, "SHIPPED_STATUS", 'shipped');
_defineProperty(Order, "CANCELED_STATUS", 'canceled');
_defineProperty(Order, "DELIVERED_STATUS", 'delivered');
_defineProperty(Order, "PROCESSING_STATUS", 'processing');
_defineProperty(Order, "RETURNED_STATUS", 'returned');
_defineProperty(Order, "WAREHOUSE_PAID_STATUS", 'w-paid');
_defineProperty(Order, "SELLER_PAID_STATUS", 's-paid');
_defineProperty(Order, "WAREHOUSE_NOT_PAID_STATUS", 'w-nop');
_defineProperty(Order, "SELLER_NOT_PAID_STATUS", 's-nop');
_defineProperty(Order, "NEW_CALL_STATUS", 'new');
_defineProperty(Order, "CALL_STATUS", 'call');
_defineProperty(Order, "FIRST_CALL_STATUS", 'call-1');
_defineProperty(Order, "SECOND_CALL_STATUS", 'call-2');
_defineProperty(Order, "THIRD_CALL_STATUS", 'call-3');
_defineProperty(Order, "FOURTH_CALL_STATUS", 'call-4');
_defineProperty(Order, "WRONG_NUMBER_STATUS", 'wrong-number');
_defineProperty(Order, "NO_REPLY_STATUS", 'no-reply');
_defineProperty(Order, "EXPIRED_STATUS", 'expired');
_defineProperty(Order, "SCHEDULED_STATUS", 'scheduled');
_defineProperty(Order, "WRONG_COUNTRY_STATUS", 'wrong-country');
export default Order;